import React, { useEffect } from "react";
import {Selections} from "./features/selectors/selectors";
import './App.css';
import { useSelector } from 'react-redux';
import { Topics } from './features/topics/topics';
import { Sidepanel } from './features/sidepanel/sidepanel.jsx'
import { Legend } from './features/legend/legend.jsx'
import { compose as C, filter as f, find, prop as p, propEq } from 'ramda';
import CookieConsent, {getCookieConsentValue,Cookies,} from "react-cookie-consent"; 
import  { Icons } from "./icons"
import ReactGA from "react-ga4";
import { Menus } from "./features/menus/menus.js";
import { Tour } from "./features/tour.jsx";

const GA_MEASUREMENT_ID = "G-DFTMSM5662";
let lastTrackedView = null;

const isDebugAnalyticsHost = () => (
  ["localhost", "127.0.0.1"].includes(window.location.hostname)
);

const initAnalytics = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gtagOptions: {
      debug_mode: isDebugAnalyticsHost(),
      send_page_view: false,
    },
  });
};

const getCurrentViewKey = () => (
  window.location.pathname + window.location.search + window.location.hash
);

const buildViewContext = ({ country, countries, bubble, conf, select, comparison, eustNr }) => {
  const { pathname, search, hash } = window.location;
  const indicator = find(propEq("id", bubble), conf);

  return {
    view_context: `${pathname}${search}${hash}`,
    page_path: pathname || "/",
    query_string: search || "",
    hash_fragment: hash || "",
    country_name: countries[country] || "",
    indicator_name: indicator ? indicator.Name : "",
    subindicator_name: select && select.active ? select.active : "",
    comparison_group: comparison.join(","),
    eust_nr: String(eustNr || ""),
  };
};

const trackPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: getCurrentViewKey(),
    title: document.title,
  });
};

const trackViewContext = (context) => {
  ReactGA.event("view_context", buildViewContext(context));
};

const trackCurrentView = (context) => {
  const currentView = getCurrentViewKey();
  if (lastTrackedView === currentView) {
    return;
  }

  trackPageView();
  trackViewContext(context);
  lastTrackedView = currentView;
};

function App() {
  const country = useSelector(p("country"));
  const countries = useSelector(p("countries"));
  const bubble = useSelector(p("bubble"));
  const conf = useSelector(p("conf"));
  const select = useSelector(p("select"));
  const comparison = useSelector(p("comparison"));
  const eustNr = useSelector(p("eust_nr"));

  const handleAccept = () => {
    initAnalytics();
    trackCurrentView({ country, countries, bubble, conf, select, comparison, eustNr });
  };
  const handleDecline = () => {
    Cookies.remove("_ga");
    Cookies.remove("_gat");
    Cookies.remove("_gid");
    lastTrackedView = null;
  };

  useEffect(() => {
    const isConsent = getCookieConsentValue();
    if (isConsent === "true") {
      initAnalytics();
      trackCurrentView({ country, countries, bubble, conf, select, comparison, eustNr });
    }
  }, [country, countries, bubble, conf, select, comparison, eustNr]);

  useEffect(() => {
    const onLocationChange = () => {
      const isConsent = getCookieConsentValue();
      if (isConsent === "true") {
        trackCurrentView({ country, countries, bubble, conf, select, comparison, eustNr });
      }
    };

    const onPopState = () => {
      window.dispatchEvent(new Event("locationchange"));
    };

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function(...args) {
      const result = originalPushState.apply(this, args);
      window.dispatchEvent(new Event("locationchange"));
      return result;
    };

    window.history.replaceState = function(...args) {
      const result = originalReplaceState.apply(this, args);
      window.dispatchEvent(new Event("locationchange"));
      return result;
    };

    window.addEventListener("popstate", onPopState);
    window.addEventListener("locationchange", onLocationChange);

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      window.removeEventListener("popstate", onPopState);
      window.removeEventListener("locationchange", onLocationChange);
    };
  }, [country, countries, bubble, conf, select, comparison, eustNr]);

  return (
    <div>
        <Icons />
        <div className={"App"}>
          <Selections/>   
          <div className={"mainpanel"}>
            <Topics data={useSelector(C(f(propEq("parent","")),p("conf")))}/>
            <Legend />
            <Sidepanel />
            <Menus/>
            <Tour/>
          </div>
        </div>
        <CookieConsent 
          enableDeclineButton
          onAccept={handleAccept}
          onDecline={handleDecline}
          buttonClasses="consent-btn"
          declineButtonClasses="consent-btn"
          containerClasses="consent"
          contentClasses="consent-text"
          disableStyles={true}>
          Country Profiles tool uses cookies to analyze how it is being used.
        </CookieConsent>
    </div>
  );
}

export default App;